import { Link } from 'react-router-dom';

/**
 * What a capture screen shows when no institution in this tenant has that mode switched on.
 *
 * ⚠ THE MENU HIDES IT; THE ROUTE STILL ANSWERS. A bookmark, a link in a WhatsApp group, a browser
 * that remembers the last page — all of them land here. A blank screen or a 404 reads as "the thing
 * you were shown in the demo is gone"; this reads as a setting, and says who can change it.
 */
export function CaptureOff({ mode, blurb }: { mode: string; blurb: string }) {
  return (
    <div className="card" style={{ padding: 28, maxWidth: 560, margin: '40px auto', textAlign: 'center' }}>
      <div className="eyebrow" style={{ marginBottom: 8 }}>Attendance</div>
      <h1 className="h-display" style={{ fontSize: 22, marginBottom: 8 }}>{mode} is switched off</h1>
      <p style={{ color: 'var(--ink-2)', fontSize: 13, marginTop: 0 }}>{blurb}</p>
      <p style={{ color: 'var(--ink-3)', fontSize: 13 }}>
        An administrator can switch it on under{' '}
        <Link to="/attendance/settings">Attendance settings</Link>. Until then, use{' '}
        <Link to="/attendance">the name list</Link>.
      </p>
    </div>
  );
}
